import { AxiosResponse } from 'axios';
import { ActCategory } from 'shell/models/act-category-list';
import { HttpResponse } from 'shell/models/http-response';
import {
  CitizenFormType,
  EditDataControl,
  Parenthood,
  SubscriptionAccordionGenerality,
} from 'subscription/view-models/common-interface-subscription';
import { transformEditDataControl } from './transform-edit-data-control';
import { transformGenerality } from './transform-generality';
import { transformBirthdayDocument } from './transform-birthday-document';
import { ActManagementForm } from 'shell/view-models/act-form';
import { transformParenthood } from './transform-parenthood';
import { AccordionFamilyCoexistence } from 'shell/view-models/accordion-family-coexistence';
import { transformFamilyCoexistence } from './transform-family-coexistence';
import { transformCitizen } from './transform-citizen';
import { checkError } from './check-error';
import { ResponseFamilyDetail } from 'notifications-from-civil-status/view-models/response-family-detail';

export const transformFamilyDetail = (
  response: AxiosResponse<HttpResponse<ActCategory>>,
  isCohabitation?: boolean,
  isOther?: boolean,
  isMother?: boolean,
  isFather?: boolean
): ResponseFamilyDetail => {
  const castedRes = response.data.payload.consultazioneANSCResponse?.modelEventoDTO || [];
  const modelEventoDTO = castedRes[0] || {};

  const castedDatiAggiuntiviSide = response.data.payload.datiAggiuntiviSide || {};

  const intestatari = castedDatiAggiuntiviSide.intestatariTranscod || [];
  const intestatario = intestatari[0] || {};
  const padre = castedDatiAggiuntiviSide.padreTranscod;
  const madre = castedDatiAggiuntiviSide.madreTranscod;

  const editDataControl: EditDataControl = transformEditDataControl(
    modelEventoDTO,
    isCohabitation,
    isOther,
    isMother,
    isFather,
    intestatario
  );
  const generality: SubscriptionAccordionGenerality = transformGenerality(
    intestatario,
    modelEventoDTO
  );
  const birthdayDocument: ActManagementForm = transformBirthdayDocument(
    modelEventoDTO,
    castedDatiAggiuntiviSide
  );
  const fatherhood: Parenthood = transformParenthood(padre);
  const motherhood: Parenthood = transformParenthood(madre);
  const citizenship: CitizenFormType = transformCitizen(intestatario, padre, madre);
  const familyCoexistence: AccordionFamilyCoexistence = transformFamilyCoexistence(intestatario);

  const errorIntestatario: string = checkError(intestatario);

  return {
    data: {
      editDataControl,
      generality,
      birthdayDocument,
      fatherhood,
      motherhood,
      citizenship,
      familyCoexistence,
    },
    error: errorIntestatario,
  };
};
